module.exports = __webpack_public_path__ + "static/media/delete.7876d178.svg";